export default singleGolfMainContent => {
    // console.log('singleGolfMainContent');
    const currentURL = window.location.origin + window.location.pathname;
    const hash = window.location.hash.substr(1);
    //const hash = "";
    const menuNav = document.querySelector('#hero-top-menu');
    const menuNavLinks = menuNav.querySelectorAll('li button');
    const mainContent = document.querySelector('.main-content');
    const tabContents = mainContent.querySelectorAll('.tab-content');

    //alert(hash);
    if(hash !== ''){
        let headerSticky = document.querySelector('.main-header.sticky');
        let headerStickyHeight = typeof(headerSticky) != 'undefined' && headerSticky != null ? headerSticky.offsetHeight : document.querySelector('.main-header').offsetHeight;

        let section = document.getElementById(hash);
        let offset = section.getBoundingClientRect().top + window.pageYOffset - 215;
        //console.log(offset, headerStickyHeight)
        window.scrollTo({top: offset, behavior: 'smooth'});
    }
/*
    function urlUpdate(tab) {
        window.history.replaceState(null, null, `${currentURL}#${tab}`);
    }

    function menuUpdate(tab) {
        for (const menuNavLink of menuNavLinks) {
            const dataContent = menuNavLink.getAttribute('data-content');

            menuNavLink.parentNode.classList.remove('current-menu-item');

            if (dataContent === tab) {
                menuNavLink.parentNode.classList.add('current-menu-item');
            }
        }
    }

    function toggleContent(tab) {
        for (const tabContent of tabContents) {
            tabContent.classList.remove('active');

            if (tabContent.id === tab) {
                tabContent.classList.add('active');
            }
        }
    }

    if (hash !== '') {
        toggleContent(hash);
        menuUpdate(hash);
    }

    for (const menuNavLink of menuNavLinks) {
        menuNavLink.addEventListener('click', event => {
            const dataContent = event.target.getAttribute('data-content');

            toggleContent(dataContent);
            menuUpdate(dataContent);
            urlUpdate(dataContent);
        });
    }*/
};
